module.exports = __webpack_public_path__ + "img/roadmap-info.a6e9c100.svg";